import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { get } from 'lodash';
import React from 'react';
import { Form, OriCheckbox, OriNumberInput } from 'src/components/Antd';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import Tip from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/DiscountLastExpression';
import ProductsApplyToRadioAndTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductsApplyToRadioAndTable';
import { maxMoney } from 'src/tools/constant';
import { isNumber } from 'src/tools/helper';
import { last4Precision } from 'src/tools/regExp';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
const _base = 'applyTo';
const _discountValue = ['discountMethod', 'percentage'];
const _discountApplyTo = 'conditionType';
const _products = 'products';
const _enabledMaxAmount = 'maxTimesEnabled';
const _maxAmount = 'maxTimes';

const PercentageOff = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { currency = 'HKD', disableEdit } = props;
  return (
    <SectionWrapper
      title={getI18n('salesChannelDirectDiscount.discountValue.discountValue')}>
      <Section bottomBorder className={css.innerSection}>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={getI18n(
                    'salesChannelDirectDiscount.discountValue.discountValue',
                  )}>
                  <Item
                    name={_discountValue}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isNumber(value)) {
                            return Promise.reject(
                              new Error(
                                getI18n('general.pleasefillavalidvalue'),
                              ),
                            );
                          }
                          if (value <= 0) {
                            return Promise.reject(
                              new Error(`${getI18n('general.noLessThan')} 1`),
                            );
                          }
                          if (value >= 100) {
                            return Promise.reject(
                              new Error(`${getI18n('general.nolessthan')} 100`),
                            );
                          }
                          if (!last4Precision.test(value)) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'salesChannelDirectDiscount.discountValue.fourDecimal',
                                ),
                              ),
                            );
                          }
                          //
                        },
                      },
                    ]}>
                    <OriNumberInput
                      size='large'
                      suffix={'%'}
                      disabled={disableEdit}
                    />
                  </Item>
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
      </Section>
      <Section bottomBorder className={css.productSection}>
        <ProductsApplyToRadioAndTable
          currency={currency}
          radioName={[_base, _discountApplyTo]}
          tableName={[_base, _products]}
          tableId={'SalesChannelDirectDiscountPercentageOff'}
          disableEdit={disableEdit}
        />
      </Section>
      <Section bottomBorder className={css.generalSection}>
        <Item name={[_base, 'flashSaleExcluded']} valuePropName={'checked'}>
          <OriCheckbox disabled={disableEdit}>
            {getI18n(
              'salesChannelDirectDiscount.discountValue.excludeflashsaleitems',
            )}
          </OriCheckbox>
        </Item>
      </Section>
      <Section bottomBorder className={css.generalSection}>
        <Item name={[_base, _enabledMaxAmount]} valuePropName={'checked'}>
          <OriCheckbox disabled={disableEdit}>
            {getI18n('salesChannelDirectDiscount.discountValue.setMax')}
          </OriCheckbox>
        </Item>
        <Item
          shouldUpdate={(p, c) => {
            const pV = get(p, [_base, _enabledMaxAmount]);
            const cV = get(c, [_base, _enabledMaxAmount]);
            return pV !== cV;
          }}>
          {({ getFieldValue }) => {
            const checked = getFieldValue([_base, _enabledMaxAmount]);
            if (checked) {
              return (
                <div className={css.maxContainer}>
                  <Item
                    name={[_base, _maxAmount]}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isNumber(value)) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'salesChannelDirectDiscount.discountValue.reasonablePrice',
                                ),
                              ),
                            );
                          }
                          if (value <= 0) {
                            return Promise.reject(
                              new Error(`${getI18n('general.noLessThan')} 1`),
                            );
                          }
                          if (value > maxMoney) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'salesChannelDirectDiscount.discountValue.reasonablePrice',
                                ),
                              ),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      size='large'
                      suffix={currency}
                      max={maxMoney}
                      precision={2}
                      disabled={disableEdit}
                    />
                  </Item>
                </div>
              );
            }
            return null;
          }}
        </Item>
      </Section>
      <Tip
        title={getI18n(
          'salesChannelDirectDiscount.discountValue.discountCalculationrule',
        )}
        content={getI18n('salesChannelDirectDiscount.discountValue.ruleTip')}
      />
    </SectionWrapper>
  );
};
export default PercentageOff;
